import makeCrud from '@/store/site/localization/crud'

// Özellik setleri (ürün tipleri) — kod/ad bazlı, payload doğrudan gönderilir.
export default makeCrud('ecommerce_product_attribute_set')
